import styled from "styled-components";
import {LiveCasinoGridItemInfoItemDefaultBox} from "./live-casino-grid-item-info-item.default.box";

export const LiveCasinoGridItemInfoItemSIBox = styled(LiveCasinoGridItemInfoItemDefaultBox)`
    font-size: 1.2em;
    letter-spacing: 0.48px;
`;
